import { render, staticRenderFns } from "./serviceRegisterManage.vue?vue&type=template&id=55131586&scoped=true"
import script from "./serviceRegisterManage.vue?vue&type=script&lang=js"
export * from "./serviceRegisterManage.vue?vue&type=script&lang=js"
import style0 from "./serviceRegisterManage.vue?vue&type=style&index=0&id=55131586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55131586",
  null
  
)

export default component.exports